import { NavigableButton } from '@carvana/ds-button';
import { useCallback } from 'react';
import DsModal from '@/common/DsModal';
import { useModalContext } from '~/context/new-cars/ModalContext/ModalContext';
import useClosestVehicle from '~/hooks/new-cars/selectors/useClosestVehicle';
import PriceBreakdownContent from './PriceBreakdownContent';

function NavigateToVehicle({ vehicleId }: { vehicleId: number }) {
  return (
    <div className="px-2xl pb-2xl sm:px-4xl sm:pb-4xl">
      <NavigableButton
        className="w-full"
        data-analytics-attributes={JSON.stringify({
          level: 'Options',
          section: 'Price Breakdown Modal',
          text: 'View Vehicle'
        })}
        data-analytics-id="New Cars"
        data-testid="panel-view-vehicle"
        href={`/vehicle/${vehicleId}`}
        size="md"
        variant="primary"
      >
        View Vehicle
      </NavigableButton>
    </div>
  );
}

export default function PriceBreakdownModal() {
  const { isPriceBreakdownModalOpen, setPriceBreakdownModalOpen } =
    useModalContext();
  const closestVehicle = useClosestVehicle();

  const onClose = useCallback(
    () => setPriceBreakdownModalOpen(false),
    [setPriceBreakdownModalOpen]
  );

  return closestVehicle?.vehicleId ? (
    <DsModal
      bottomButtonContent={
        <NavigateToVehicle vehicleId={closestVehicle.vehicleId} />
      }
      classes={{
        body: 'pb-xl sm:pb-2xl',
        header: 'pb-0'
      }}
      desktopWidth="480px"
      isOpen={isPriceBreakdownModalOpen}
      mobileStyle="inset"
      modalHeader="Price Breakdown"
      onClose={onClose}
    >
      <div className="flex flex-col gap-lg">
        <PriceBreakdownContent />
      </div>
    </DsModal>
  ) : null;
}
